import partners from './partners'
import complexes from './complexes'
import actionStatuses from './action-statuses'
import complexTypes from './complex-types'
import regions from './regions'
import regionsvacancy from './regions-vacancy'
import objectTypes from './object-types'
import objectStatuses from './object-statuses'
import objectSteps from './object-steps'
import objects from './objects'
import scheduleObjects from './schedule-objects'
import scheduleComplexes from './schedule-complexes'
import checklistObjects from './checklist-objects'
import checklistComplexes from './checklist-complexes'
import layouts from './layouts'
import orgSpheres from './org-spheres'
import sites from './sites'
import markTypes from './mark-types'
import developers from './developers'
import jsontemplates from './jsontemplates'
import genplanMarkTypes from './genplan-mark-types'

export default {
  dictionary: {
    namespaced: true,
    modules: {
      partners,
      actionStatuses,
      complexes,
      complexTypes,
      regions,
      regionsvacancy,
      objectTypes,
      objectStatuses,
      objectSteps,
      objects,
      scheduleObjects,
      scheduleComplexes,
      checklistObjects,
      checklistComplexes,
      layouts,
      orgSpheres,
      sites,
      markTypes,
      developers,
      jsontemplates,
      genplanMarkTypes
    }
  }
}
